<template>
  <b-modal
    id="modal-scrollable"
    v-model="$store.state.someVariables.showNewSancionRead"
    size="lg"
    scrollable
    no-close-on-backdrop
    title="Sancion"
    @hidden="resetModal"
  >
    <b-row>
      <b-col md="1"
        ><span
          style="background: #dedede;
    padding: 3px;
    border-radius: 4px; font-size:11px"
          >{{ dataSancion.id_campeonato }}</span
        ></b-col
      >
      <b-col
        md="5"
        style="background: #dedede;
    padding: 3px;
    border-radius: 4px; font-size:11px"
        >Etapa {{ dataSancion.etapa }} - fecha #
        {{ dataSancion.num_fecha }} jugado el {{ dataSancion.fecha_aux }}</b-col
      >

      <b-col md="6" style="text-align:right"
        ><span
          style="background: #dedede;
    padding: 3px;
    border-radius: 4px;font-size:11px"
          >{{ dataSancion.local }} vs {{ dataSancion.visita }}</span
        ></b-col
      >
    </b-row>
    <b-row>
      <b-col md="5">
        <b-row>
          <b-col style="text-align:center" md="12">
            <img class="mt-1" width="50%" :src="dataSancion.foto_jug" alt="" />
          </b-col>
          <b-col md="12">
            <v-select
              placeholder="C.I / Pasaporte"
              :clearable="false"
              class="mb-1 mt-1"
              v-model="dataSancion.ci_pasaporte"
              :options="[]"
              disabled
            />
          </b-col>
          <b-col md="12" style="margin-top:5px">
            <div class="form-label-group">
              <b-form-input
                id="floating-nombres"
                placeholder="Ingrese Nombres"
                size="sm"
                :formatter="formatter"
                :disabled="true"
                :value="dataSancion.nombre"
              />
              <label for="floating-nombres">Nombres</label>
            </div>
          </b-col>
          <b-col md="12" style="margin-top:5px">
            <div class="form-label-group">
              <b-form-input
                id="floating-apellidos"
                placeholder="Ingrese Apellidos"
                :formatter="formatter"
                size="sm"
                :disabled="true"
                :value="dataSancion.apellido"
              />
              <label for="floating-apellidos">Apellidos</label>
            </div>
          </b-col>
          <b-col md="12" style="margin-top:5px">
            <div class="form-label-group">
              <b-form-input
                id="floating-club"
                placeholder="Ingrese Club"
                :formatter="formatter"
                :disabled="true"
                size="sm"
                :value="dataSancion.equipo"
              />
              <label for="floating-club">Club</label>
            </div>
          </b-col>
          <b-col md="12" style="margin-top:5px">
            <div class="form-label-group">
              <b-form-input
                id="floating-camiseta"
                placeholder="Ingrese # Camiseta"
                :formatter="formatter"
                :disabled="true"
                size="sm"
                :value="dataSancion.num_camiseta"
              />
              <label for="floating-club"># Camiseta</label>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col md="7">
        <span v-show="false">{{ setearComputed }}</span>
        <b-tabs>
          <b-tab
            v-if="
              dataSancion.tipo == 'n' ||
                dataSancion.tipo == '' ||
                dataSancion.tipo == undefined
            "
            :active="dataSancion.tipo == 'n' ? true : false"
            title="Normal"
          >
            <b-row>
              <b-col md="12">
                <img
                  v-if="dataSancion.t_r == '1'"
                  :src="require('@/assets/images/recursos/roja.png')"
                  alt=""
                  width="20"
                  class="mr-1"
                />
                <img
                  v-else-if="dataSancion.doble_a == '1'"
                  :src="require('@/assets/images/recursos/dosamar.png')"
                  alt=""
                  width="20"
                  class="mr-1"
                />
                <img
                  v-else-if="dataSancion.acumulacion == 1"
                  :src="require('@/assets/images/recursos/amarilla.png')"
                  alt=""
                  width="20"
                  class="mr-1"
                />
                <small class="mr-1" v-if="dataSancion.t_r == '1'"
                  >ROJA DIRECTA
                </small>
                <small class="mr-1" v-else-if="dataSancion.doble_a == '1'"
                  >ROJA POR DOBLE AMARILLA
                </small>
                <small class="mr-1" v-else-if="dataSancion.acumulacion == 1"
                  >ACUMULACION DE AMARILLAS
                </small>
              </b-col>
              <b-col md="9" class="mt-1">
                <span>{{ dataSancion.motS }}</span>
              </b-col>

              <b-col md="12">
                <b-form-textarea
                  id="textarea-auto-height"
                  placeholder="Detalle del articulo"
                  rows="2"
                  size="sm"
                  max-rows="3"
                  disabled
                  v-model="dataSancion.reglamento"
                />
              </b-col>

              <b-col md="12" style="text-align:right">
                <span
                  :id="`pop_info_importante`"
                  style="text-decoration:underline;color:red;cursor:pointer;font-size:10px"
                  >IMPORTANTE</span
                >
                <b-popover
                  ref="popover"
                  :target="`pop_info_importante`"
                  triggers="hover"
                  :show.sync="popoverShowIA"
                  placement="auto"
                  style="background:red !important"
                >
                  <div style="background:red;color:white; text-align:center">
                    <span>RECUERDA</span>
                  </div>
                  <div
                    style="max-height: 350px; overflow-y: auto; background:yellow;padding:5px"
                  >
                    El sistema buscará todos los partidos que esten pendientes
                    de jugarse, es decir mostrara fechas menores o mayores a
                    donde se obtuvo la tarjeta, te brindamos las herramientas
                    necesarias para no cometer errores, Asegurate de validar la
                    información o corrigela de ser el caso
                  </div>
                </b-popover>
              </b-col>
              <b-col md="12" style="margin-top:10px">
                <div class="form-label-group">
                  <b-form-input
                    v-if="dataSancion.aprobado == 'n'"
                    id="floating-duracion"
                    placeholder="Duración"
                    :formatter="formatter"
                    type="number"
                    size="sm"
                    value="3"
                    v-model="dataSancion.duracion"
                  />
                  <label for="floating-duracion">Duración</label>
                </div>
              </b-col>
              <b-col md="1">
                <div style="width:13px;height:13px; background:#f3f39d"></div>
              </b-col>
              <b-col md="11" style="padding:0">
                <div style="font-size:10px;color:gray">
                  partidos menores a la fecha# {{ dataPartido.num_fecha }} donde
                  obtuvo la tarjeta
                </div>
              </b-col>
              <b-col md="1">
                <div style="width:13px;height:13px; background:#f8c867"></div>
              </b-col>
              <b-col md="11" style="padding:0">
                <div style="font-size:10px;color:gray">
                  partidos mayores a la fecha# {{ dataPartido.num_fecha }} donde
                  obtuvo la tarjeta
                </div>
              </b-col>

              <b-col md="12">
                <b-row
                  class="mt-1"
                  style="background-color:#e3e0e0; color:white; padding-top:5px; padding-bottom:5px"
                >
                  <b-col
                    md="12"
                    class="border-right d-flex justify-content-center align-items-center"
                    ><small
                      style="font-size:12px; font-weight:bold;color:#b93333"
                      >Detalle de partidos suspendidos
                    </small>
                  </b-col>
                </b-row>
                <b-row
                  class="mt-0 p-0 border"
                  style="background-color:#f1efef; color:white"
                >
                  <b-col
                    md="1"
                    class=" d-flex justify-content-center align-items-center"
                    style="padding:5px; "
                    ><small
                      style="font-size:10px; font-weight:bold;color:#b93333"
                      >Etapa</small
                    >
                  </b-col>
                  <b-col
                    md="1"
                    class="border-right d-flex justify-content-center align-items-center"
                    style="padding:5px"
                    ><small
                      style="font-size:10px; font-weight:bold;color:#b93333"
                      >Fecha</small
                    >
                  </b-col>
                  <b-col
                    style="padding:5px"
                    md="8"
                    class="text-center border-right"
                    ><small
                      style="font-size:10px; font-weight:bold;color:#b93333"
                      >Partido</small
                    >
                  </b-col>
                  <b-col
                    md="1"
                    class="d-flex justify-content-center align-items-center"
                    style="margin-left:5px"
                  ></b-col>
                </b-row>
                <b-overlay
                  :show="loadingPartidos"
                  rounded="sm"
                  :class="loadingPartidos ? 'mt-2' : 'mt-0'"
                >
                  <b-row
                    v-for="item in dataSancion.detalle_partidos"
                    :key="item.id"
                    class="mt-0 p-0 border"
                  >
                    <b-col
                      md="1"
                      :class="
                        Number(item.etapa) <= Number(dataPartido.etapa) &&
                        Number(item.num_fecha) < Number(dataPartido.num_fecha)
                          ? 'etapa'
                          : 'etapa-mayor'
                      "
                      style="padding:5px"
                      ><small>{{ item.etapa }}</small>
                    </b-col>
                    <b-col
                      md="1"
                      style="padding:5px"
                      :class="
                        Number(item.etapa) <= Number(dataPartido.etapa) &&
                        Number(item.num_fecha) < Number(dataPartido.num_fecha)
                          ? 'etapa'
                          : 'etapa-mayor'
                      "
                      ><small>{{ item.num_fecha }}</small>
                    </b-col>
                    <b-col
                      md="8"
                      style="padding:5px"
                      class="text-center border-right"
                      ><span
                        style="color: #929292;font-size: 10px;border-radius: 4px;float: left;background: #dddddd;padding-left: 3px;padding-right: 3px"
                        >{{ item.id_campeonato }}</span
                      ><small>{{ item.local }} vs {{ item.visita }}</small>
                    </b-col>
                    <b-col
                      v-if="isManual && item.final == 'PJ'"
                      md="1"
                      class="d-flex justify-content-center align-items-center"
                      style="margin-left:10px"
                      ><b-form-checkbox v-model="item.elegido">
                      </b-form-checkbox
                    ></b-col>
                  </b-row>
                </b-overlay>
              </b-col>
            </b-row>
            <div
              style="color:white;margin-top:5px;font-size: 14px;padding: 5px; background-color:#f24320; border-radius:3px"
              v-if="restantes > 0"
              md="12"
            >
              La sanción sera marcada como PENDIENTE, quedarán
              <b> {{ restantes }}</b>
              partidos pendientes para completar la sanción en la siguiente
              etapa
            </div>
            <div
              style="color:white;margin-top:5px;font-size: 14px;padding: 5px; background-color:#f24320; border-radius:3px"
              v-if="dataSancion.num_pendientes > 0"
              md="12"
            >
              SANCIÓN "POR ACTUALIZAR", quedan
              <b> {{ dataSancion.num_pendientes }}</b>
              partidos pendientes que deben ser sancionados en la nueva etapa
            </div>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
    <template #modal-footer>
      <b-col
        v-if="dataSancion.id_sancion !== undefined"
        md="12"
        style="margin-top:10px;font-size: 12px;padding: 3px; background-color:gold; border-radius:3px"
      >
        <span
          ><b
            >Aplicada: {{ dataSancion.inicio_auxiliar }} por
            {{ dataSancion.userAplica }}</b
          >
        </span>
      </b-col>
      <b-col
        v-if="
          dataSancion.id_auditoria !== undefined &&
            dataSancion.id_auditoria !== null
        "
        md="12"
        style="margin-top:5px;font-size: 12px;padding: 3px; background-color:#fff8a5; border-radius:3px"
      >
        <span
          ><b
            >Modificada: {{ dataSancion.fecha_mod }}, ver auditoria #
            {{ dataSancion.id_auditoria }}</b
          >
        </span>
      </b-col>
      <div class="w-100">
        <template v-if="!showLoading"> </template>
        <div v-if="showLoading" class="text-center mt-1">
          <b-spinner variant="primary" label="Text Centered" />
        </div>
      </div>
    </template>
  </b-modal>
</template>
<script>
import {
  BRow,
  BCol,
  BFormInput,
  BModal,
  BTabs,
  BTab,
  BFormCheckbox,
  // BButton,
  BSpinner,
  BOverlay,
  BFormTextarea,
  BPopover,
  // BListGroup,
  // BListGroupItem,
  // cxxx
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { heightFade } from '@core/directives/animations'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, computed, watch } from '@vue/composition-api'
import apiCall from '../../utils/apiCall'
import {
  URL,
  // MOTIVOS_PRINCIPALES_SANCION,
  USER,
  ROLES,
} from '../../utils/variables'

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BModal,
    vSelect,
    BTabs,
    BTab,
    BFormCheckbox,
    // BButton,
    BSpinner,
    BOverlay,
    BFormTextarea,
    BPopover,

    // BListGroup,
    // BListGroupItem,
  },
  directives: {
    // 'b-tooltip': VBTooltip,
    Ripple,
    heightFade,
  },
  props: {
    dataSancion: Object,
    dataPartido: Object,
    arrayPartidos: Array,
    listMotivos: Array,
    setear: Boolean,
    especialUnico: Boolean,
    categoriaSeleccionada: Object,
    isManualProp: Boolean,
    isOpen: Boolean,
  },
  setup(props, { emit }) {
    // eslint-disable-next-line
    const isManual = computed({
      get: () => props.isManualProp,
      set: value => {
        // props.isManualProp = value
        emit('changeManual', value)
      },
    })
    const listPartidos = ref([])
    const listPlayers = ref([])
    const duracion = ref(null)
    // const rangeSancion = ref(null)
    const { getApi } = apiCall()
    const etapaInicia = ref(null)
    const fechaInicia = ref(null)
    const showLoading = ref(false)
    const messageError = ref('')
    const detalleReglamento = ref('')
    const variante = ref('danger')
    // const tipoSancion = ref('n')
    const loadingPartidos = ref(false)
    const boton = ref()
    const duracionEspecial = ref(null)
    const dataRangeSancion = ref(null)
    const restantes = ref(0)
    const popoverShowIA = ref(null)

    // let listPartidos = computed({
    //   get: () => props.dataSancion.listPartidos,
    //   set: value => {
    //     // props.dataSancion.listPartidos = value
    //   },
    // })

    // async function getDetalleSancion(idTarjeta, idEquipo) {
    //   console.log(props)
    //   const path = `ApiSanciones/getSancionIdTarjetaRel/${idTarjeta}/${idEquipo}`
    //   const data = await getApi(URL, path)
    //   // console.log(data.data)
    //   // item.duracion = data.data.duracion
    //   // item.motivo = data.data.motS
    //   // item.listPartidos = data.detalle
    //   // dataSancion.value = item
    //   props.dataSancion.value.listPartidos = data.detalle
    //   // partidosSuspendidos.value = data.detalle
    //   // const action = store.getters['someVariables/getSancion']
    // }
    function changeManual() {
      // emit('changeManual')
    }

    // const duracionEspecial = computed(() => calculaDuracion())
    // const duracionEspecial = computed({
    //   get: () => {
    //     // return store.getters['someVariables/getSancion']
    //     props.dataSancion.duracionEspecial
    //   },
    //   set: value => {
    //     props.dataSancion.duracionEspecial = value
    //   },
    // })
    function changeRange() {
      emit('changeRange', props.dataSancion.rangeSancion)
      // duracionEspecial.value = calculaDuracion()
    }

    const setearComputed = computed({
      get: () => {
        if (props.setear) {
          // console.log(props.dataSancion)
          duracionEspecial.value = props.dataSancion.duracionEspecial
          listPartidos.value = props.dataSancion.listPartidos
        }
        // return store.getters['someVariables/getSancion']
        return props.setear
      },
      set: value => {
        props.setear = value
      },
      // () => {
      // console.log('cambio data')
      // console.log(props.setear)
      // if (props.setear) {
      //   listPartidos.value = props.dataSancion.listPartidos
      // }
      // // return store.getters['someVariables/getSancion']
      // return props.setear
    })

    // const rangeSancion = ref(
    //   computed(
    //     // eslint-disable-next-line
    //     () =>
    //     // eslint-disable-next-line
    //       `${props.dataSancion.fecha_incio_sancion} to ${props.dataSancion.fecha_fin_especial}`
    //     // eslint-disable-next-line
    //   )
    // )
    function cerroCalendario() {
      // console.log(rangeSancion.value)
      if (props.dataSancion.rangeSancion === '') {
        duracionEspecial.value = null
      }
    }

    function formatter(value) {
      return value.toUpperCase()
    }
    function defineTipoSancion(tipo) {
      // console.log(tipo)
      // tipoSancion.value = tipo
      emit('changeTipoSancion', tipo)
    }
    // function definirEtapaFechaInicioSancion() {
    //   etapaInicia.value = listPartidos.value[0].etapa
    //   fechaInicia.value = listPartidos.value[0].num_fecha
    //   // etapaInicia.value = props.dataSancion.listPartidos[0].etapa
    //   // fechaInicia.value = props.dataSancion.listPartidos[0].num_fecha
    // }
    function calcularRestantes() {
      return props.dataSancion.duracion - listPartidos.value.length
    }
    async function getPartidosAutomatico(value) {
      // console.log(value)
      // props.dataSancion.listPartidos = []
      listPartidos.value = []
      if (value != null) {
        if (value.length >= 1) {
          loadingPartidos.value = true
          const path = `ApiSanciones/getPartidosASuspender/${props.dataSancion.id_equipo}/${value}/${props.dataPartido.num_fecha}/${props.dataPartido.id_campeonato}`
          const data = await getApi(URL, path)
          listPartidos.value = data.data
          restantes.value = calcularRestantes()
          // dataSancionAuxiliar.value.listPartidos = data.porSuspender
          // store.commit(
          //   'someVariables/UPDATE_SANCION',
          //   // eslint-disable-next-line
          //   props.dataSancion
          // )
          loadingPartidos.value = false
          // definirEtapaFechaInicioSancion()
        } else {
          // console.log('dos')
          // props.dataSancion.listPartidos = []
          listPartidos.value = []
          etapaInicia.value = null
          fechaInicia.value = null
          restantes.value = 0
        }
      }
    }
    async function getPartidosManual(value) {
      // console.log(props.dataPartido)
      // isManual.value = true
      // props.dataSancion.listPartidos = []

      // if(props.dataSancion.id_sancion!=null){
      //
      // }
      // console.log(props.dataSancion.motivo)
      listPartidos.value = []
      let data
      // console.log(isManual.value)
      if (isManual.value) {
        restantes.value = 0
        loadingPartidos.value = true
        const path = `ApiSanciones/partidosPendienteSancion/${props.dataSancion.id_equipo}/${value}/${props.dataPartido.id_campeonato}`
        data = await getApi(URL, path)
        // props.dataSancion.listPartidos = data.porSuspender
        let dataObtenida = []
        if (props.dataSancion.aprobado === 's') {
          emit('resetSetear')
          dataObtenida = data.suspendidos.concat(data.porSuspender)
        } else {
          dataObtenida = data.porSuspender
        }
        // console.log(dataObtenida)
        // dataObtenida.forEach(element => {
        //   element.elegido = false
        // })
        listPartidos.value = dataObtenida
        props.dataSancion.duracion = 0
        loadingPartidos.value = false
      } else {
        listPartidos.value = []
        if (
          props.dataSancion.motivo !== undefined &&
          props.dataSancion.motivo != null
        ) {
          props.dataSancion.duracion =
            props.dataSancion.motivo.dataReglamento.total_partidos
        } else {
          props.dataSancion.duracion = undefined
        }

        getPartidosAutomatico(props.dataSancion.duracion)
        if (props.dataSancion.aprobado === 's') {
          emit('trueSetear')
        }
      }
      // dataSancionAuxiliar.value.listPartidos = data.porSuspender
      // store.commit(
      //   'someVariables/UPDATE_SANCION',
      //   // eslint-disable-next-line
      //   props.dataSancion
      // )
      // dataSancionAuxiliar.value.listPartidos = data.porSuspender
      // console.log(dataSancionAuxiliar.value)
      // definirEtapaFechaInicioSancion()
    }
    watch(isManual, () => {
      // if (data) {
      const isOpen = store.getters['someVariables/getStateShowNewSancion']
      if (isOpen) {
        getPartidosManual(props.dataSancion.id_sancion)
      }
      // }
    })

    // watch(boton, valor => {
    //   console.log(valor)
    //   // if (valor) {
    //   //   manual('0')
    //   // } else {
    //   //   console.log('nada')
    //   // }
    // })

    function showNewMotivoOnly() {
      emit('onlyMotivo')
    }
    function funcionalidadMotivo(item) {
      if (item.label !== null) {
        props.dataSancion.detalle = `${
          item.dataReglamento.detalle == null ? '' : item.dataReglamento.detalle
        } (valor ${item.dataReglamento.valor})`
        props.dataSancion.duracion = item.dataReglamento.total_partidos
        props.dataSancion.duracion_recomendada =
          item.dataReglamento.total_partidos
        getPartidosAutomatico(props.dataSancion.duracion_recomendada)
        // console.log(item.value)
        if (item.value === undefined) {
          item.value = null
        }
      }
    }
    function changeMotivo(item) {
      // console.log(item)
      if (!isManual.value) {
        funcionalidadMotivo(item)
      }
    }
    function resetModal(bvModalEvt) {
      bvModalEvt.preventDefault()
      store.commit('someVariables/UPDATE_SHOW_NEW_SANCION', false)

      // emit('recargar', props.playerSelected.id_equipo)
      // hasError.value = false
      listPartidos.value = []
      // props.setear = false
      emit('resetSetear')
      emit('changeManual', false)

      props.dataSancion.motivo = null
      props.dataSancion.duracion = 0
      // isManual.value = false
      showLoading.value = false
      props.dataSancion.rangeSancion = null
      dataRangeSancion.value = null
      duracionEspecial.value = null
      props.dataSancion.detalle = null
      restantes.value = 0
      store.commit(
        'someVariables/UPDATE_ACTIVATE_SANCION_PENDIENTE',
        // eslint-disable-next-line
        false
      )
    }
    function onlyClose() {
      store.commit('someVariables/UPDATE_SHOW_NEW_SANCION', false)
      store.commit(
        'someVariables/UPDATE_ACTIVATE_SANCION_PENDIENTE',
        // eslint-disable-next-line
        false
      )
    }

    return {
      formatter,
      isManual,
      // listPartidos,
      getPartidosAutomatico,
      duracion,
      etapaInicia,
      fechaInicia,
      showLoading,
      messageError,
      variante,
      defineTipoSancion,
      // tipoSancion,
      changeMotivo,
      resetModal,
      onlyClose,
      // arrayAuxiliar,
      // dataSancionAuxiliar,
      getPartidosManual,
      boton,
      listPartidos,
      setearComputed,
      // rangeSancion,
      duracionEspecial,
      cerroCalendario,
      changeRange,
      listPlayers,
      loadingPartidos,
      ROLES,
      USER,
      showNewMotivoOnly,
      detalleReglamento,
      changeManual,
      restantes,
      popoverShowIA,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
.danger {
  background-color: #ea5454c7;
  border-radius: 5px;
  color: white;
}
.success {
  background-color: #2be025c7;
  border-radius: 5px;
  color: white;
}
.etapa {
  border-right: 1px solid #ebe9f1;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(243, 243, 157);
}
.etapa-mayor {
  border-right: 1px solid #ebe9f1;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(248, 200, 103);
}
</style>
